import { ChannelsCard } from './channels-card';
import { DefaultsCard } from './defaults-card';
import { RoutingExplainer } from './routing-explainer';
import { SettingsCard } from './settings-card';

/** Tab "General rules" (plan 9.2): market defaults, global switches, how a lead is routed, webhook URLs. */
export function GeneralTab() {
  return (
    <>
      <DefaultsCard />
      <SettingsCard />
      <RoutingExplainer />
      <ChannelsCard />
    </>
  );
}
